// extracted by mini-css-extract-plugin
export default {"content":"content__iltaI","row__field":"row__field__mTA3R","row__label":"row__label__gvy7O","row__label__descr":"row__label__descr__jU8Co"};